import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'

class FilterJob extends Component {
  onChange = values => {
    const { activeJobs, setMyJobsDataViewerFilter } = this.props
    const jobs = ArrayHelper.getArrData(values, [])

    if (!isEqual(jobs, activeJobs.toArray())) {
      setMyJobsDataViewerFilter({ jobs })
    }
  }

  render() {
    const { activeJobs, jobList } = this.props
    const values = ArrayHelper.getValues(activeJobs, jobList)

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        outMultipleValues={{
          all: [],
          empty: [-1],
        }}
        variant="outlined"
        name="jobs"
        label={formatMessage('jobs')}
        list={jobList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'title',
        }}
      />
    )
  }
}

FilterJob.defaultProps = {
  activeJobs: List([]),
  jobList: List([]),
}

FilterJob.propTypes = {
  activeJobs: PropTypes.instanceOf(List),
  jobList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeJobs: store.getIn(['profile', 'jobsDataViewerFilters', 'jobs']),
    jobList: store.getIn(['myJobsDataViewer', 'filters', 'jobs']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterJob)
